import { Typography } from '@mui/material';

import { TableCellCustom } from '@app/components/table';
import { RowActions } from './row-actions';
interface Props {
  row?: any;
  selected: boolean;
  onSelectRow: VoidFunction;
  canAddPortfolio?: string;
}

const PortfolioRow = (props: Props) => {
  const { row, canAddPortfolio } = props;

  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row?.id}</Typography>
      </TableCellCustom>
      <TableCellCustom width={180}>
        <Typography variant="body2">{row?.name}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <Typography variant="body2">{row?.description}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <Typography variant="body2">{row?.category}</Typography>
      </TableCellCustom>

      {canAddPortfolio ? (
        <TableCellCustom align="right" width={50}>
          <RowActions row={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { PortfolioRow };
